import styled from 'styled-components';
import { boxShadow, breakpoints, colors, spacing } from '@chegg-ui/theme';
import { Radio } from '@chegg-ui/radio';
import { Tag } from '@chegg-ui/tag';
import { Size } from './constants';
export var PriceContainer = styled.div.withConfig({
  componentId: "sc-32nxd8-0"
})(["display:flex;flex-direction:column;justify-content:center;gap:2px;@media (max-width:", "){margin-left:45px;}"], breakpoints.sm.max);
export var RowContainer = styled.div.withConfig({
  componentId: "sc-32nxd8-1"
})(["display:inline-block;width:100%;cursor:pointer;", ""], function (_ref) {
  var size = _ref.size;
  return size === Size.COMPACT && "\n    [data-test='upsell'] {\n      margin: 0 auto;\n      right: 0px;\n    }\n    [data-test='variation-container'] {\n      flex-direction: column;\n      gap: ".concat(spacing.px16, ";\n    }\n  \n    [data-test='price-container'] {\n      margin-left: 45px;\n    }\n  ");
});
export var StyledPrice = styled.div.withConfig({
  componentId: "sc-32nxd8-2"
})(["color:", ";font-size:", ";font-weight:", ";"], colors.grey950, function (_ref2) {
  var theme = _ref2.theme;
  return theme.cuiTheme.font.size.lg4;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.cuiTheme.font.weight.medium;
});
export var StyledRadio = styled(Radio).withConfig({
  componentId: "sc-32nxd8-3"
})(["min-width:250px;flex-grow:0;& > div{padding-left:", ";}@media (max-width:", "){width:unset;}"], spacing.px24, breakpoints.sm.max);
export var StyledSubtext = styled.div.withConfig({
  componentId: "sc-32nxd8-4"
})(["color:", ";font-size:", ";font-weight:", ";@media (max-width:", "){font-size:", ";}"], colors.grey800, function (_ref4) {
  var theme = _ref4.theme;
  return theme.cuiTheme.font.size.lg;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.cuiTheme.font.weight.normal;
}, breakpoints.sm.max, function (_ref6) {
  var theme = _ref6.theme;
  return theme.cuiTheme.font.size.md;
});
export var StyledTag = styled(Tag).attrs(function () {
  return {
    passive: true
  };
}).withConfig({
  componentId: "sc-32nxd8-5"
})(["& > span > div:first-child{background-color:", ";box-shadow:none;color:", ";font-size:", ";font-weight:", ";}"], colors.violet100, colors.violet700, function (_ref7) {
  var theme = _ref7.theme;
  return theme.cuiTheme.font.size.xs;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.cuiTheme.font.weight.normal;
});
export var StyledTitle = styled.div.withConfig({
  componentId: "sc-32nxd8-6"
})(["color:", ";font-size:", ";font-weight:", ";"], colors.grey950, function (_ref9) {
  var theme = _ref9.theme;
  return theme.cuiTheme.font.size.lg2;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.cuiTheme.font.weight.bold;
});
export var Upsell = styled.div.withConfig({
  componentId: "sc-32nxd8-7"
})(["background-color:", ";border-radius:6px 6px 0 0;color:", ";font-size:", ";font-weight:", ";padding:", ";width:155px;text-align:center;position:relative;margin-left:auto;right:50px;@media (max-width:", "){margin:0 auto;right:0px;}"], colors.violet500, colors.white, function (_ref11) {
  var theme = _ref11.theme;
  return theme.cuiTheme.font.size.md;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.cuiTheme.font.weight.medium;
}, spacing.px4, breakpoints.sm.max);
export var VariationContainer = styled.div.withConfig({
  componentId: "sc-32nxd8-8"
})(["display:flex;background-color:", ";box-shadow:", ";box-sizing:border-box;border:3px solid ", ";border-radius:", ";padding:", ";@media (max-width:", "){flex-direction:column;gap:", ";}"], colors.white, boxShadow.Hover, function (_ref13) {
  var isSelected = _ref13.isSelected;
  return isSelected ? colors.orange800 : 'transparent';
}, spacing.px8, spacing.px16, breakpoints.sm.max, spacing.px16);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductVariationRow/styled.js
// module id = 4055
// module chunks = 11